var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('OperationDetailsDialog',{ref:"genericDialog"}),_vm._l((_vm.operationComponents),function(op,key){return _c('div',{key:key},[_c(op,{ref:("op_" + key),refInFor:true,tag:"component"})],1)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }